import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import Alerts from '../../../../prototypes/Alerts';
import EtelAPI from '../../../../api/EtelAPI';
import Overlay from '../../../../presentation/Overlay';
import DeleteItemDialog from '../../../../presentation/DeleteItemDialog';
import EditSectionLabel from '../../../../presentation/EditSectionLabel';
import EditSectionDropdown from '../../../../presentation/EditSectionDropdown';
import EditSectionInput from '../../../../presentation/EditSectionInput';
import EditSectionTextArea from '../../../../presentation/EditSectionTextArea';
import ReactTooltip from 'react-tooltip';

class WholesaleTFNSplitDialogList extends Component {
  constructor( props ) {
    super( props );

    this.state = {
      row: props.row === undefined ? {} : props.row,
      dataSource: [],
      showDeleteDialog: false,
      isNew: false
    };

    this.onHandleClickSave = this.onHandleClickSave.bind( this );

    this.onHandleChange = this.onHandleChange.bind( this );
    this.onHandleClickDelete = this.onHandleClickDelete.bind( this );
    this.onHandleClickInsert = this.onHandleClickInsert.bind( this );
    this.onHandleClickUpdate = this.onHandleClickUpdate.bind( this );
    this.onHandleClickCancel = this.onHandleClickCancel.bind( this );
    this.onHandleClickConfirmDelete = this.onHandleClickConfirmDelete.bind( this );
    this.onHandleClickNewSplit = this.onHandleClickNewSplit.bind( this );

    this.onHandleException = this.onHandleException.bind( this );

    this.title = 'Wholesale TFN/DID Split';
  }

  /****************************************************************************
   * STATE / LIFECYCLE METHODS
   ***************************************************************************/

  componentDidMount() {
    this.alert = new Alerts( this.props.bugsnag, this.props.dispatch );

    this.getData();
  }

  /****************************************************************************
   * API CALLS
   ***************************************************************************/

  getData() {
    const row = { ...this.state.row };
    const splitParams = [
      { WS_Company_ID: row.Company_ID }
    ];

    const all = () => Promise.all( [
      this.getSplit( splitParams )
    ] ).then( ( [splitResults] ) => {
      this.setState( {
        dataSource: splitResults
      } );
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );

    all();
  }

  getSplit( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'wholesale/tfnsplit' );

      api.get( params ).then( ( splitResults ) => {
        resolve( splitResults );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  updateSplit( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'wholesale/tfnsplit' );

      api.update( params ).then( ( splitResults ) => {
        resolve( splitResults );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  insertSplit( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'wholesale/tfnsplit' );

      api.insert( params ).then( ( splitResults ) => {
        resolve( splitResults );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  deleteSplit( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'wholesale/tfnsplit' );

      api.delete( params ).then( ( splitResults ) => {
        resolve( splitResults );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  /****************************************************************************
   * EXCEPTION HANDLING
   ***************************************************************************/

  doLogOff() {
    const { dispatch, auth, history } = this.props;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  onHandleException( e ) {
    const { dispatch, bugsnag } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const status = e.status === undefined ? 0 : e.status;
    if ( status === 410 ) {
      alerts.INFO( this.title, 'Your session has expired.', 5000 );
      this.doLogOff();
    } else if ( status === 500 ) {
      alerts.INFO( this.title, e.statusText, 5000 );
    } else {
      if ( e.statusText !== undefined ) {
        alerts.CRITICAL( this.title, e, false );
      } else {
        alerts.CRITICAL( this.title, e );
      }
    }
  }

  /****************************************************************************
   * HELPER METHODS
   ***************************************************************************/

  /****************************************************************************
  * EVENT HANDLING
  ****************************************************************************/

  onHandleChange( e ) {
    const updatedTFNSplitData = { ...this.state.dataSource[0] };
    updatedTFNSplitData[e.target.column] = e.target.value;

    this.setState( {
      dataSource: [updatedTFNSplitData]
    } );
  }

  onHandleClickInsert( args ) {
    const { rowIndex } = args;
    const splitToInsert = { ...this.state.newItem[rowIndex] };
    const params = {
      WS_Company_ID: this.state.row.Company_ID,
      Active: splitToInsert.Active,
      TFN_DNIS: splitToInsert.TFN_DNIS,
      DID_DNIS: splitToInsert.DID_DNIS,
      Exception_TFN: splitToInsert.Exception_TFN,
      Exception_DID: splitToInsert.Exception_DID,
      TFN_DNIS_SPLIT_PCNT: splitToInsert.TFN_DNIS_SPLIT_PCNT,
      DID_DNIS_SPLIT_PCNT: splitToInsert.DID_DNIS_SPLIT_PCNT
    };

    this.insertSplit( params ).then( ( result ) => {
      const updatedDataSource = [...this.state.dataSource];
      updatedDataSource.unshift( result.data[0] );

      this.setState( {
        dataSource: updatedDataSource
      }, () => {
        this.setNewItem();
      } );

      this.alert.SUCCESS( this.title, `Successfully inserted ${this.title}.`, 2500 );
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );
  }

  onHandleClickUpdate( args ) {
    const { rowIndex } = args;
    const splitToUpdate = { ...this.state.dataSource[rowIndex] };
    const params = {
      WS_Company_ID: splitToUpdate.WS_Company_ID,
      Active: splitToUpdate.Active,
      TFN_DNIS: splitToUpdate.TFN_DNIS,
      DID_DNIS: splitToUpdate.DID_DNIS,
      Exception_TFN: splitToUpdate.Exception_TFN,
      Exception_DID: splitToUpdate.Exception_DID,
      TFN_DNIS_SPLIT_PCNT: splitToUpdate.TFN_DNIS_SPLIT_PCNT,
      DID_DNIS_SPLIT_PCNT: splitToUpdate.DID_DNIS_SPLIT_PCNT
    };

    this.updateSplit( params ).then( ( result ) => {
      this.alert.SUCCESS( this.title, `Successfully updated ${this.title}.`, 2500 );
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );
  }

  onHandleClickDelete( args ) {
    if ( this.state.isNew ) {
      this.setState( {
        dataSource: []
      } );
    } else {
      this.setState( {
        showDeleteDialog: true
      } );
    }
  }

  onHandleClickCancel( e ) {
    this.setState( {
      showDeleteDialog: false
    } );
  }

  onHandleClickConfirmDelete( e ) {
    const splitItem = { ...this.state.dataSource[0] };
    const companyID = this.state.dataSource[0].WS_Company_ID;

    this.deleteSplit( companyID ).then( ( result ) => {
      const updatedDataSource = this.state.dataSource.filter( ( splitInfo ) => {
        return splitInfo.WS_Company_ID !== companyID;
      } );

      this.setState( {
        dataSource: updatedDataSource,
        showDeleteDialog: false
      } );

      this.alert.SUCCESS( this.title, `Successfully deleted ${this.title}.`, 2500 );

      this.props.onDelete( splitItem );
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );
  }

  onHandleClickNewSplit( e ) {
    const newDataSource = [
      {
        WS_Company_ID: this.state.row.Company_ID,
        Company: this.state.row.Company,
        TFN_DNIS: "",
        DID_DNIS: "",
        Exception_TFN: "",
        Exception_DID: "",
        TFN_DNIS_SPLIT_PCNT: 1.00,
        DID_DNIS_SPLIT_PCNT: 1.00,
        Active: 1
      }
    ];

    this.setState( {
      dataSource: newDataSource,
      isNew: true
    } );
  }

  onHandleClickSave( e ) {
    const splitInfo = { ...this.state.dataSource[0] };
    const params = {
      WS_Company_ID: this.state.row.Company_ID,
      Active: splitInfo.Active,
      TFN_DNIS: splitInfo.TFN_DNIS,
      DID_DNIS: splitInfo.DID_DNIS,
      Exception_TFN: splitInfo.Exception_TFN,
      Exception_DID: splitInfo.Exception_DID,
      TFN_DNIS_SPLIT_PCNT: splitInfo.TFN_DNIS_SPLIT_PCNT,
      DID_DNIS_SPLIT_PCNT: splitInfo.DID_DNIS_SPLIT_PCNT
    };

    if ( this.state.isNew ) {
      this.insertSplit( params ).then( ( result ) => {
        const updatedDataSource = [...this.state.dataSource];
        updatedDataSource.unshift( result.data[0] );

        this.setState( {
          dataSource: updatedDataSource,
          isNew: false
        } );

        this.alert.SUCCESS( this.title, `Successfully inserted ${this.title}.`, 2500 );

        this.props.onSave( { row: result.data[0] } );
      } ).catch( ( exception ) => {
        this.onHandleException( exception );
      } );
    } else {
      this.updateSplit( params ).then( ( result ) => {
        this.alert.SUCCESS( this.title, `Successfully updated ${this.title}.`, 2500 );

        this.props.onSave( { row: result.data[0] } );
      } ).catch( ( exception ) => {
        this.onHandleException( exception );
      } );
    }
  }

  /****************************************************************************
   * RENDERS
   ***************************************************************************/

  render() {
    if ( this.state.dataSource.length === 0 ) {
      return (
        <span>
          <span className='wholesale-dialog-header-content'>
            {
              this.state.dataSource.length === 0
              &&
              <button
                className='dialog-save-button'
                style={{ width: '250px', height: '32px' }}
                onClick={this.onHandleClickNewSplit}
              >
                New TFN/DID Split
            </button>
            }
          </span>
        </span>
      );
    }

    const row = this.state.dataSource[0];
    const showOverlay = this.state.showDeleteDialog;

    return (
      <div
        style={{
          display: "grid",
          width: "100%",
          gridTemplateRows: "635px 40px"
        }}
      >
        <div>
          <span className='tfn-did-split-group-field'>
            <span className='tfn-did-split-label'>Company</span>
            <EditSectionLabel Text={row.Company} hilite />
          </span>
          <span className='tfn-did-split-group-field'>
            <span className='tfn-did-split-label'>TFN DNIS</span>
            <EditSectionInput columnName='TFN_DNIS' value={row.TFN_DNIS} width='150px' onChanged={this.onHandleChange} autoFocus={true} />
          </span>
          <span className='tfn-did-split-group-field'>
            <span className='tfn-did-split-label'>DID DNIS</span>
            <EditSectionInput columnName='DID_DNIS' value={row.DID_DNIS} width='150px' onChanged={this.onHandleChange} />
          </span>
          <span className='tfn-did-split-group-field'>
            <span className='tfn-did-split-label'>Exception TFNs <i className='icon-fontello-help-circled-1 tfn-did-split-exceptions-tooltip' data-tip='exception-tfn' data-for='exception-tfn' /></span>
            <ReactTooltip id="exception-tfn" type="info">
              Place TFNs in this field separated by commas. TFNs placed here that receive calls will be routed to the DID DNIS.
            </ReactTooltip>
            <EditSectionTextArea columnName='Exception_TFN' value={row.Exception_TFN} width='100%' height='75px' onChanged={this.onHandleChange} />
          </span>
          <span className='tfn-did-split-group-field'>
            <span className='tfn-did-split-label'>Exception DIDs <i className='icon-fontello-help-circled-1 tfn-did-split-exceptions-tooltip' data-tip='exception-did' data-for='exception-did' /></span>
            <ReactTooltip id="exception-did" type="info">
              Place DIDs in this field separated by commas. DIDs placed here that receive calls will be routed to the TFN DNIS.
            </ReactTooltip>
            <EditSectionTextArea columnName='Exception_DID' value={row.Exception_DID} width='100%' height='75px' onChanged={this.onHandleChange} />
          </span>
          <span className='tfn-did-split-group-field'>
            <span className='tfn-did-split-label'>TFN Split Percentage <i className='icon-fontello-help-circled-1 tfn-did-split-exceptions-tooltip' data-tip='pcnt-tfn' data-for='pcnt-tfn' /></span>
            <ReactTooltip id="pcnt-tfn" type="info">
              A decimal value represented as a percentage from 0.00 to 1.00 goes here. 0.00 is 0% and 1.00 is 100%. Example: 0.55 = 55%.
            </ReactTooltip>
            <EditSectionInput columnName='TFN_DNIS_SPLIT_PCNT' value={row.TFN_DNIS_SPLIT_PCNT} width='150px' onChanged={this.onHandleChange}  />
          </span>
          <span className='tfn-did-split-group-field'>
            <span className='tfn-did-split-label'>DID Split Percentage <i className='icon-fontello-help-circled-1 tfn-did-split-exceptions-tooltip' data-tip='pcnt-did' data-for='pcnt-did' /></span>
            <ReactTooltip id="pcnt-did" type="info">
              A decimal value represented as a percentage from 0.00 to 1.00 goes here. 0.00 is 0% and 1.00 is 100%. Example: 0.55 = 55%.
            </ReactTooltip>
            <EditSectionInput columnName='DID_DNIS_SPLIT_PCNT' value={row.DID_DNIS_SPLIT_PCNT} width='150px' onChanged={this.onHandleChange} />
          </span>
          <span className='tfn-did-split-group-field'>
            <span className='tfn-did-split-label'>Active</span>
            <EditSectionDropdown columnName="Active" width="150px" value={row.Active} options={[{ id: 0, text: "Inactive" }, { id: 1, text: "Active" }]} onChanged={this.onHandleChange} />
          </span>
        </div>
        <div className='tfn-did-split-button-group'>
          <button className='tfn-did-split-save-button' onClick={this.onHandleClickSave}>Save</button>
          <button className='tfn-did-split-delete-button' onClick={this.onHandleClickDelete}>{this.state.isNew ? "Cancel" : "Delete"}</button>
          <button className='tfn-did-split-cancel-button' onClick={this.props.onClose}>Close</button>
        </div>
        {
          showOverlay && <Overlay show={showOverlay} />
        }
        {
          this.state.showDeleteDialog &&
          <DeleteItemDialog
            show={this.state.showDeleteDialog}
            layout={{ newbutton: { caption: this.title } }}
            onCancel={this.onHandleClickCancel}
            onConfirm={this.onHandleClickConfirmDelete}
          />
        }
      </div>
    );
  }
};

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( WholesaleTFNSplitDialogList ) );


// WEBPACK FOOTER //
// ./src/content/wholesale/tfnsplit/components/WholesaleTFNSplitEditDialog.js